import { ProcessedCell, TableColumn, TextSearchConfig } from '../types';
import { deriveColumnId } from '../data/table-data-functions';

export function filterRowsBySearch(
	rows: ProcessedCell[][],
	columns: TableColumn[],
	searchTerm: string,
	textSearch?: TextSearchConfig
): number[] {
	const query = searchTerm.trim().toLowerCase();
	if (!query) {
		return rows.map((_, index) => index);
	}

	// Restrict to configured column ids, or search all columns when omitted.
	const searchableColumnIndices = columns
		.map((col, index) => ({
			index,
			id: deriveColumnId(col, index),
		}))
		.filter(({ id, index }) => {
			if (!textSearch?.ids?.length) return true;
			return textSearch.ids.includes(columns[index].id ?? id);
		})
		.map(({ index }) => index);

	return rows.reduce<number[]>((matches, row, rowIndex) => {
		const hasMatch = searchableColumnIndices.some(colIndex => {
			const cell = row[colIndex];
			return cell && !cell.isEmpty && cell.text.toLowerCase().includes(query);
		});
		if (hasMatch) matches.push(rowIndex);
		return matches;
	}, []);
}

export function formatResultsText(totalCount: number, visibleCount: number): string {
	if (visibleCount < totalCount) {
		return `Showing ${visibleCount} of ${totalCount} Results`;
	}
	return `Showing ${totalCount} Results`;
}
